import React from 'react'
import PropTypes from 'prop-types'

import Services from '@src/Services'
import { Input } from '@src/components/Form/Input'
import { Checkbox } from '@src/components/Form/Checkbox'
import SocialLoginButtons from '@src/components/SocialLoginButtons'

const SHOW_SOCIAL_LOGIN = false

const Form = ({
  handleSubmit,
  showTitle,
  isBgsSite,
  disabled,
  email,
  handleEmailChange,
  errors,
  password,
  handlePasswordChange,
  linkedinLoginUrl,
  googleLoginUrl,
  phoneNumber,
  handlePhoneNumber,
  termsAndConditions,
  handleTermsAndConditionsChange,
}) => (
  <form
    noValidate
    onSubmit={(event) => {
      event.preventDefault()
      handleSubmit()
    }}
    className="signup__form"
    autoComplete="new-off"
  >
    {showTitle && (
      <h1 className="govuk-heading-l govuk-!-margin-bottom-6">
        Create an account
      </h1>
    )}

    
    <Input
      label="Email address"
      id="email"
      type="email"
      disabled={disabled}
      value={email.toLowerCase()}
      onChange={(item) => handleEmailChange(item.email)}
      errors={errors.email || []}
    />
    <Input
      label="Password"
      id="password"
      type="password"
      description="Your password must have at least 10 characters, including letters and numbers."
      descriptionClassName= 'govuk-!-margin-bottom-1 great-font-main great-line-height-30 great-font-size-18 govuk-body-l great-text-dark-grey'
      disabled={disabled}
      value={password}
      onChange={(item) => handlePasswordChange(item.password)}
      errors={errors.password || []}
      isPasswordShowHide={true}
    />
    <Checkbox
      id="terms_and_conditions"
      label= {
        <>
        I have read and agree to the{' '}
        <a href="/terms-and-conditions/">terms and conditions<span class="govuk-visually-hidden"> (opens in a new tab)</span></a>.
        </>
      }
      checked={termsAndConditions}
      onChange={handleTermsAndConditionsChange}
      errors={errors.terms_and_conditions || []}
      disabled={disabled}
    />
    <p className="signup__conditions">
          Read our{' '}
          <a href="/privacy/">privacy notice</a> to understand how we use your personal information.
    </p>
    <button
      type="submit"
      id="signup-modal-submit"
      className="great-ds-button"
      disabled={disabled}
    >
      Create account
    </button>
    {SHOW_SOCIAL_LOGIN && (
      <>
        <div className="govuk-!-margin-top-4 govuk-!-margin-bottom-4">
          <hr className="bg-blue-deep-10" />
          <span>or</span>
          <hr className="bg-blue-deep-10" />
        </div>
        <SocialLoginButtons
          linkedinUrl={linkedinLoginUrl}
          googleUrl={googleLoginUrl}
          action="Sign up"
        />
      </>
    )}
     <p className="govuk-!-margin-bottom-9 govuk-!-margin-top-0">
      Already have an account?{' '}
      <a
        href={Services.config.loginUrl} id="signup-modal-log-in"
      >
        Sign in
      </a>
    </p>
  </form>
)

Form.propTypes = {
  disabled: PropTypes.bool,
  errors: PropTypes.shape({
    email: PropTypes.arrayOf(PropTypes.string),
    password: PropTypes.arrayOf(PropTypes.string),
    terms_and_conditions: PropTypes.arrayOf(PropTypes.string),
  }),
  handlePasswordChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleEmailChange: PropTypes.func.isRequired,
  password: PropTypes.string,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  handlePhoneNumber: PropTypes.func.isRequired,
  linkedinLoginUrl: PropTypes.string.isRequired,
  googleLoginUrl: PropTypes.string.isRequired,
  showTitle: PropTypes.bool,
  termsAndConditions: PropTypes.bool.isRequired,
  handleTermsAndConditionsChange: PropTypes.func.isRequired,
}

Form.defaultProps = {
  showTitle: true,
  disabled: false,
  errors: {},
  password: '',
  email: '',
  phoneNumber: null,
  termsAndConditions: false,
}

export default Form
